<script setup>
import {onMounted, onUnmounted, ref, watch} from "vue";

const { value = 0, choices } = defineProps({
    value: [Number, String],
    choices: Object,
});

const emit = defineEmits(['change', 'input']);

const group = ref('group');
const span = ref('span');

const realValue = ref( value );

function handleClick(choice) {
    emit('input', choice );
    emit('change', choice );
    realValue.value = choice;
}

const computeSize = () => {
    const button = group.value.querySelector('[data-value="' + realValue.value + '"]');

    if ( button ) {
        const posX = button.getBoundingClientRect().left - group.value.getBoundingClientRect().left;

        span.value.style.width = button.getBoundingClientRect().width + 'px';
        span.value.style.left = posX + 'px';
    }
};

watch( () => value, new_value => {
    realValue.value = new_value;
} );

watch( realValue, () => {
    computeSize();
} );

onMounted( () => {
    computeSize();
    window.addEventListener('resize', computeSize );
} );

onUnmounted( () => {
    window.removeEventListener('resize', computeSize );
} );
</script>

<template>
    <div class="grouped-buttons" ref="group">
        <button v-for="( label, choice ) in choices" @click.prevent="() => handleClick( choice )"
                :data-value="choice" :class="{ active: realValue === choice }" :name="label">
            <slot v-bind:label="label">{{ label }}</slot>
        </button>
        <span ref="span">&nbsp;</span>
    </div>

</template>